import React from "react";
import _image_service from "../../services/ImageService";
import './ElementIcon.scss';

interface ElementIconProps {
    className?: string,
    name: string,
}

const ElementIcon = (props: ElementIconProps) => {

    const formatName = (name: string): string => {
        return name.charAt(0).toUpperCase() + name.substring(1).toLowerCase();
    }

    return (
        <>
            <img className={(props.className ? props.className + ' ' : '') + "magic-element-image"}
                 src={_image_service.getCdnImageSrc(`chase/world/magic/elements/${props.name.toLowerCase()}.png`)}
                 title={formatName(props.name)}
                 alt={formatName(props.name)}/>
        </>
    );
}

export default ElementIcon;